// import React, { useEffect, useState } from "react";
// import { Col, Row, Container, Image } from "react-bootstrap";
// import MessageActions from "./MessageActions";
// import { useWorkspace } from "../../../contexts/WorkspaceContext";
// import TypingIndicator from "./TypingIndicator";
// import  black_logo  from "../../../assets/modalX_robot_icon_black.png";
// import  white_logo  from "../../../assets/modalX_robot_icon_white.png";
// // import ReactMarkdown from "react-markdown";
// import ReactMarkdown from 'react-markdown'
// import remarkGfm from 'remark-gfm'


// const MessageCard = ({ message, handleDownload, handlePreview }) => {

//   console.log("current_messages_from_history",message)
//   const {waitThread} = useWorkspace();
//   // const theme = localStorage.getItem('theme');
//   const [theme,setTheme] = useState(localStorage.getItem('theme'));
//   const [currUrl,setCurrUrl] = useState(null);
//   const findUrl = (msg) => {
//     const urlRegex = /(https?:\/\/[^']*?\.(mp3|mp4|pptx|jpg|jpeg|png|txt|ppt))/g;
//     const match = urlRegex.exec(msg);
//     return match ? match[1] : null;
//   };

//   useEffect(() => {
//     // Update the theme when it changes
//     setTheme(localStorage.getItem('theme'));
//   }, [localStorage.getItem('theme')]);
//   console.log("here is the extracted url",currUrl)

//   const handleCopyToClipboard = (text) => {
//     navigator.clipboard.writeText(text)
//       .then(() => {
//         console.log('Link copied to clipboard:', text);
//       })
//       .catch((error) => {
//         console.error('Error copying link to clipboard:', error);
//       });
//   };
//   return (
//     <Container fluid >
      
//       {message.sender? 
//       <Row className="pb-3">
//         {message.sender === "user" ? (
//           <>
//             <Col xs={11} className="text-start" style={{marginBottom:'20px',paddingRight:'70px'}}>
//               <Row>
//                 <Col xs={1} className="d-flex flex-column justify-content-start align-items-center p-0 m-0">
//                   <i className="bi bi-person fs-4" />
//                 </Col>
//                 <Col xs={11} style={{margin:'auto'}}>
//                   {/* {message.content.split("\n").map((line, index) => (
//                     <div key={index} style={{ wordBreak: "break-word" }}>
//                       {line}
//                     </div>
//                   ))} */}
//                   {message.content && typeof message.content === 'string' && message.content.split("\n").map((line, index) => (
//                     <div key={index} style={{ wordBreak: "break-word" }}>
//                       {line}
//                     </div>
//                   ))}
//                 </Col>
//               </Row>
//             </Col>
//           </>
//         ) : (
//           <Row className="justify-content-end">
//             <Col xs={11} className="text-end" style={{marginBottom:'40px'}}>
//               <Row>
//                 <Col xs={11} style={{margin:'auto',paddingRight:message.content.length < 42 ?'20px':''}} className={message.content.length > 42 ? "text-start" :'text-end'}>
//                   {/* {message.content.split("\n").map((line, index) => (
//                     <div key={index} style={{ wordBreak: "break-word" }}>
//                       {line}
//                     </div>
//                   ))} */}
//                   {findUrl(message.content) ?
//                     (
//                       <div>
//                         {/* {message.content && typeof message.content === 'string' && message.content.split("\n\n")[0].replace(/\[.*?\]\(.*?\)/, '').slice(0, -4)} */}
//                         {message.content &&
//                           typeof message.content === 'string' &&
//                           message.content.split("\\n").map((paragraph, index) => {
//                             const boldRegex = /\*\*(.*?)\*\*/g;
//                             const formattedParagraph = paragraph.replace(
//                               boldRegex,
//                               "<strong>$1</strong>"
//                             );
//                             return (
//                               <div
//                                 key={index}
//                                 style={{ wordBreak: "break-word" }}
//                                 // dangerouslySetInnerHTML={{ __html: formattedParagraph }}
//                               ><ReactMarkdown children={paragraph} remarkPlugins={[remarkGfm]} />
//                               </div>
//                             );
//                           })}
//                       </div>
//                     )
//                     :
//                     (
//                       // <div>
//                       //   {message.content && typeof message.content === 'string' && message.content.split("\\n").map((line, index) => (
//                       //     <div key={index} style={{ wordBreak: "break-word" }}>
//                       //       {line}
//                       //     </div>
//                       //   ))}
//                       // </div>
//                       <div>
//                         {message.content &&
//                           typeof message.content === 'string' &&
//                           message.content.split("\\n").map((paragraph, index) => {
//                             const boldRegex = /\*\*(.*?)\*\*/g;
//                             const formattedParagraph = paragraph.replace(
//                               boldRegex,
//                               "<strong>$1</strong>"
//                             );
//                             return (
//                               <div
//                                 key={index}
//                                 style={{ wordBreak: "break-word" }}
//                                 // dangerouslySetInnerHTML={{ __html: formattedParagraph }}
//                               ><ReactMarkdown children={paragraph} remarkPlugins={[remarkGfm]} />
//                               </div>
//                             );
//                           })}
//                       </div>
//                     )
//                   }
                  
//                   {/* {message.content && typeof message.content === 'string' && message.content.split("\n").map((line, index) => (
//                     <div key={index} style={{ wordBreak: "break-word" }}>
//                       {line}
//                     </div>
//                   ))} */}
//                 </Col>
//                 <Col xs={1} className="d-flex flex-column justify-content-start align-items-center p-0 m-0">
//                   {/* <i className="bi bi-robot fs-4" /> */}
//                   <img style={{width:'25px',height:'25px'}} src={theme==='dark'?black_logo:white_logo} alt="modalx_logo"/>
//                 </Col>
//                 <Col>
//                   <p style={{ color: 'blue', textAlign: 'start' }}>
//                     {message.file && message.file.status === "processing" ? (
//                       <span>Please wait it's processing...</span>
//                     ) : (
//                        message.file &&
//                        <div style={{width:'100%',border:'1px solid grey',padding:'5px 10px',borderRadius:'10px',margin:'10px 10px 0 0',display:'flex',justifyContent:'space-between'}}>
//                           <a href={message.file.url} target="_blank" rel="noopener noreferrer">
//                             Link
//                           </a>
//                           <i class="bi bi-copy" style={{ cursor: 'pointer', marginRight: '5px' }} onClick={() => handleCopyToClipboard(findUrl(message.file.url))}></i>
//                        </div>
                        
//                     )}
//                   </p>
//                 </Col>

//               </Row>
//               {message.file && (
//                 <Row>
//                   <MessageActions
//                     message={message}
//                     handleDownload={handleDownload}
//                     handlePreview={handlePreview}
//                   />
//                 </Row>
//               )}
//             </Col>
//           </Row>
          
//         )}
        
//       </Row> :
      
//       <Row className="pb-3">
//         <>
//             <Col xs={11} className="text-start" style={{marginBottom:'20px',paddingRight:'70px'}}>
//               <Row>
//                 <Col xs={1} className="d-flex flex-column justify-content-start align-items-center p-0 m-0">
//                   <i className="bi bi-person fs-4" />
//                 </Col>
//                 <Col xs={11} style={{margin:'auto'}}>
//                   {/* {message.content.split("\n").map((line, index) => (
//                     <div key={index} style={{ wordBreak: "break-word" }}>
//                       {line}
//                     </div>
//                   ))} */}
//                   {message.user && typeof message.user === 'string' && message.user.split("\n").map((line, index) => (
//                     <div key={index} style={{ wordBreak: "break-word"}}>
//                       {line}
//                     </div>
//                   ))}
//                 </Col>
//               </Row>
//             </Col>
//           </>
//           <Row className="justify-content-end">
//             <Col xs={11} className="text-end">
//               <Row>
//                 <Col xs={11} style={{margin:'auto',paddingLeft:'40px',marginBottom:'40px'}} className={message.agent.length > 42 ? "text-start" :'text-end'}>
//                   {/* {message.agent && typeof message.agent === 'string' && message.agent.split("\n").map((line, index) => (
//                     <div key={index} style={{ wordBreak: "break-word" }}>
//                       {line}
//                     </div>
//                   ))} */}
//                   {findUrl(message.agent) ?
//                     (
//                       <div>
//                         {/* {message.agent && typeof message.agent === 'string' && message.agent.split("\n\n")[0].replace(/\[.*?\]\(.*?\)/, '').slice(0, -4)} */}
//                         {message.agent &&
//                           typeof message.agent === 'string' &&
//                           message.agent.split("\\n").map((paragraph, index) => {
//                             const boldRegex = /\*\*(.*?)\*\*/g;
//                             const formattedParagraph = paragraph.replace(
//                               boldRegex,
//                               "<strong>$1</strong>"
//                             );
//                             return (
//                               <div
//                                 key={index}
//                                 style={{ wordBreak: "break-word" }}
//                                 // dangerouslySetInnerHTML={{ __html: formattedParagraph }}
//                               >
//                                 <ReactMarkdown children={paragraph} remarkPlugins={[remarkGfm]} />
//                               </div>
//                             );
//                           })}
//                       </div>
//                     )
//                     :
//                     (
//                       // <div>
//                       //   {message.agent && typeof message.agent === 'string' && message.agent.split("\n").map((line, index) => (
//                       //     <div key={index} style={{ wordBreak: "break-word" }}>
//                       //       {line}
//                       //     </div>
//                       //   ))}
//                       // </div>

//                     // =========================================
//                     // <Col xs={11} style={{ margin: "auto", paddingRight: message.content.length < 42 ? "20px" : "" }} className={message.content.length > 42 ? "text-start" : "text-end"}>
//                     //   <ReactMarkdown>{message.agent}</ReactMarkdown>
//                     // </Col>
//                       // <div>
//                       //   <ReactMarkdown children={message.agent} remarkPlugins={[remarkGfm]} />
//                       // </div>
//                     // ==========================================
//                       <div>
//                         {message.agent &&
//                           typeof message.agent === 'string' &&
//                           message.agent.split("\\n").map((paragraph, index) => {
//                             const boldRegex = /\*\*(.*?)\*\*/g;
//                             const formattedParagraph = paragraph.replace(
//                               boldRegex,
//                               "<strong>$1</strong>"
//                             );
//                             return (
//                               <div
//                                 key={index}
//                                 style={{ wordBreak: "break-word" }}
//                                 // dangerouslySetInnerHTML={{ __html: formattedParagraph }}
//                               >
//                                 <ReactMarkdown children={paragraph} remarkPlugins={[remarkGfm]} />
//                               </div>
//                             );
//                           })}
//                       </div>
//                     )
//                   }
                  
//                   {/* {message.agent && typeof message.agent === 'string' && message.agent.split("\n\n")[0].replace(/\[.*?\]\(.*?\)/, '').slice(0, -4)} */}
//                   {
//                     findUrl(message.agent)&&
//                     <div style={{width:'100%',border:'1px solid grey',padding:'5px 10px',borderRadius:'10px',margin:'10px 10px 0 0',display:'flex',justifyContent:'space-between'}}>
//                         <a href={findUrl(message.agent)} target="_blank" rel="noopener noreferrer">
//                           Link
//                         </a>
//                         <i class="bi bi-copy" style={{ cursor: 'pointer', marginRight: '5px' }} onClick={() => handleCopyToClipboard(findUrl(message.agent))}></i>
//                     </div>
                    
//                   }
//                   {
//                       findUrl(message.agent) &&
//                       <Row>
//                         <MessageActions
//                           message={{
//                             file: { url: findUrl(message.agent),mode:'from_history' }
//                           }}
//                           handleDownload={handleDownload}
//                           handlePreview={handlePreview}
//                         />
//                       </Row>
//                     }
//                 </Col>
                
//                 <Col xs={1} className="d-flex flex-column justify-content-start align-items-center p-0 m-0">
//                   {/* <i className="bi bi-robot fs-4" /> */}
//                   <img style={{width:'25px',height:'25px'}} src={theme==='dark'?black_logo:white_logo} alt="modalx_logo"/>
//                 </Col>
                
//               </Row>
//               {message.file && (
//                 <Row>
//                   <MessageActions
//                     message={message}
//                     handleDownload={handleDownload}
//                     handlePreview={handlePreview}
//                   />
//                 </Row>
//               )}
//             </Col>
//           </Row>
//       </Row>
    
    
//     }
//       {/* {waitThread&& <p style={{textAlign:'end'}}><TypingIndicator /></p>} */}
//     </Container>
//   );
// };

// export default MessageCard;
//===============================updated code before on 04-09-2024  (below)=====================================
// import React, { useEffect, useState } from "react";
// import { Col, Row, Container, Image, Button } from "react-bootstrap";
// import MessageActions from "./MessageActions";
// import { useWorkspace } from "../../../contexts/WorkspaceContext";
// import TypingIndicator from "./TypingIndicator";
// import black_logo from "../../../assets/ModalX_-orange_Icon.png";
// import white_logo from "../../../assets/modalX_robot_icon_white.png";
// import ReactMarkdown from 'react-markdown';
// import remarkGfm from 'remark-gfm';
// import he from 'he';
// import sourceUrl from "../../../api/Source.api";
// import {decode} from 'html-entities';
// import markdownit from 'markdown-it';

// const MessageCard = ({ message, handleDownload, handlePreview }) => {
//   const token = localStorage.getItem('token');
//   console.log("current_messages_from_history", message);
//   const { waitThread,setCurrentThread,setWaitThread,sendMessage,setSending } = useWorkspace();
//   const [theme, setTheme] = useState(localStorage.getItem('theme'));
//   const [fileStatus, setFileStatus] = useState(null);
//   const [input, setInput] = useState("");

//   const findUrl = (msg) => {
//     const urlRegex = /(https?:\/\/[^']*?\.(mp3|mp4|pptx|jpg|jpeg|png|txt|ppt))/g;
//     const match = urlRegex.exec(msg);
//     return match ? match[1] : null;
//   };

//   const removeUrlsAndBrackets = (msg) => {
//     return msg.replace(/\(https?:\/\/[^']*?\.(mp3|mp4|pptx|jpg|jpeg|png|txt|ppt)\)/g, '');
//   };

//   useEffect(() => {
//     // Update the theme when it changes
//     const handleThemeChange = () => setTheme(localStorage.getItem('theme'));
//     window.addEventListener('storage', handleThemeChange);

//     return () => {
//       window.removeEventListener('storage', handleThemeChange);
//     };
//   }, []);

//   const handleCopyToClipboard = (text) => {
//     navigator.clipboard.writeText(text)
//       .then(() => {
//         console.log('Link copied to clipboard:', text);
//       })
//       .catch((error) => {
//         console.error('Error copying link to clipboard:', error);
//       });
//   };

//   useEffect(() => {
//     const url = findUrl(message.agent);
//     if (url) {
//       checkStatusFromHistoryUrl(url).then((status) => {
//         setFileStatus(status);
//       });
//     }
//   }, [message.agent]);

//   const checkStatusFromHistoryUrl = async (url) => {
//     try {
//       const response = await fetch(`${sourceUrl}/status`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           "Authorization": `Bearer ${token}`
//         },
//         body: JSON.stringify({ url }),
//       });

//       const responseData = await response.json();
//       if (responseData.data.status === "completed") {
//         return "completed";
//       } else if (responseData.data.status === "failed") {
//         return "failed";
//       } else {
//         return null;
//       }
//     } catch (error) {
//       console.error("Check URL status request error:", error);
//       return null;
//     }
//   };

//   const renderers = {
//     a: ({ href, children }) => (
//       <div style={{ display: 'inline-flex', alignItems: 'center', wordBreak: 'break-word' }}>
//         <a href={href} target="_blank" rel="noopener noreferrer">{children}</a>
//         <i
//           className="bi bi-copy"
//           style={{ cursor: 'pointer', marginLeft: '20px' }}
//           onClick={() => handleCopyToClipboard(href)}
//           title="Copy link"
//         />
//       </div>
//     ),
//   };

//   const decodeUnicode = (str) => {
//     return str.replace(/\\u[\dA-F]{4}/gi, (match) => {
//       return String.fromCharCode(parseInt(match.replace(/\\u/g, ''), 16));
//     });
//   };

//   // const decodeContent = (content) => {
//   //   return decodeUnicode(he.decode(content));
//   // };

//   const md = markdownit({
//     html: true,
//     linkify: true,
//     typographer: true,
//     quotes: '“”‘’',
//   })

// // Function to decode HTML entities
// const decodeContent = (content) => {
//   return decodeUnicode(decode(content));
// };

//   const handleSubmit = async (messageContent) => {
//     setSending(true)
//     setWaitThread(true);
//     if (messageContent.trim()) {
//       const latestEntry = { sender: "user", content: messageContent };
//       setInput(""); // Reset input field
//       setCurrentThread((prevThread) => [...prevThread, latestEntry]);
//       const entryResponse = await sendMessage(latestEntry).catch(console.error);
      
//       if (entryResponse) {
//         setCurrentThread((prevThread) => [...prevThread, entryResponse]);
//         setSending(false)
//       }
//       else{
//         setCurrentThread((prevThread) => [...prevThread, {content:"Unable to process your query!..",sender:'modalX'}]);
//         setSending(false);
//       }
//     }
//     setWaitThread(false);
//     // here add the functionality to check url status and update it in the currentThread
//   };

//   const handleRetry = () => {
//     setCurrentThread((prevThread) => {
//       const lastUserMessage = prevThread.filter(msg => msg.sender === "user").slice(-1)[0];
//       const newThread = prevThread.slice(0, -1);
//       handleSubmit(lastUserMessage.content); // Retry the submission with the last user message
//       return newThread;
//     });
//   };

//   const getFileFormat = (url) => {
//     // Extract the file extension from the URL
//     const parts = url.split('.');
//     if (parts.length > 1) {
//       return parts[parts.length - 1]; // Return the last part as the file format
//     } else {
//       return ''; // Return empty string if no file extension found
//     }
//   };

//   return (
//     <Container fluid > 
//       {message.sender ?
//         <Row className="pb-3" >
//           {message.sender === "user" ? (
//             <Col xs={11} className="text-start" style={{ marginBottom: '20px', paddingRight: '70px',paddingLeft:'40px'}}>
//               <Row>
//                 <Col xs={1} className="d-flex flex-column justify-content-start align-items-center p-0 m-0" style={{backgroundColor:'#1F233E',borderRadius:'50%',width:'48px',height:'48px'}}>
//                   <i className="bi bi-person fs-4" style={{margin:'auto'}}/>
//                 </Col>
//                 <Col xs={11} style={{ margin: 'auto' }}>
//                   {message.content && typeof message.content === 'string' && message.content.split("\n").map((line, index) => (
//                     <div key={index} style={{ wordBreak: "break-word" }}>
//                       {decodeContent(line)}
//                     </div>
//                   ))}
//                 </Col>
//               </Row>
//             </Col>
//           ) : (
//             <Row className="justify-content-end" >
//               <Col xs={11} className="text-end" style={{ marginBottom: '40px'}}>
//                 <Row>
//                   <Col xs={11} style={{ margin: 'auto', paddingRight: message.content.length < 44 ? '20px' : '',paddingTop:'10px'}} className={message.content.length > 55 ? "text-start" : 'text-end'}>
//                     {/* {message.content &&
//                       typeof message.content === 'string' &&
//                       message.content.split("\\n").map((paragraph, index) => {
//                         return (
//                           <div
//                             key={index}
//                             style={{ wordBreak: "break-word" }}
//                           >
//                             <ReactMarkdown children={decodeContent(paragraph)} remarkPlugins={[remarkGfm]} components={renderers} />
//                           </div>
//                         );
//                       })} */}
//                       {message.content &&
//                       typeof message.content === 'string' &&
//                       message.content.split("\\n").map((paragraph, index) => {
//                         const cleanedParagraph = findUrl(message.content) ? removeUrlsAndBrackets(paragraph) : paragraph;
//                         return (
//                           <div
//                             key={index}
//                             style={{ wordBreak: "break-word" }}
//                           >
//                             {/* <ReactMarkdown children={decodeContent(cleanedParagraph)} remarkPlugins={[remarkGfm]} components={renderers} /> */}
//                             {/* <div>{renderers}</div> */}
//                             {/* <Markdown options={{overrides: renderers, }}>{decodeContent(cleanedParagraph)}</Markdown> */}
//                             <div dangerouslySetInnerHTML={{ __html: md.render(decodeContent(cleanedParagraph)) }} />
//                           </div>
//                         );
//                       })}
//                   </Col>
//                   <Col xs={1} className="d-flex flex-column justify-content-start align-items-center p-0 m-0">
//                     <img style={{ width: '48px', height: '48px'}} src={theme === 'dark' ? black_logo : white_logo} alt="modalx_logo" />
//                   </Col>
//                 </Row>
//                 {message.file && (
//                   <Row>
//                     <MessageActions
//                       message={message}
//                       handleDownload={handleDownload}
//                       handlePreview={handlePreview}
//                     />
//                   </Row>
//                 )}
//                 {message.content === 'Unable to process your query!..' ? (
//                   <div style={{display:'flex',justifyContent:'right'}}>
//                     <Button
//                     onClick={handleRetry}
//                     style={{ marginTop: "10px",maxWidth:'300px',border:'2px solid red',backgroundColor:'transparent'}}
//                   >
//                     Regenerate Response <i class="bi bi-arrow-repeat"></i>
//                   </Button>
//                   </div>
                  
//                 ):''}
//               </Col>
//             </Row>
//           )}
//         </Row>
//         :
//         <Row className="pb-3">
//           <Col xs={11} className="text-start" style={{ marginBottom: '20px', paddingRight: '70px',paddingLeft:'40px'}}>
//             <Row>
//               <Col xs={1} className="d-flex flex-column justify-content-start align-items-center p-0 m-0" style={{backgroundColor:'#1F233E',borderRadius:'50%',width:'48px',height:'48px'}}>
//                 <i className="bi bi-person fs-4" style={{margin:'auto'}}/>
//               </Col>
//               <Col xs={11} style={{ margin: 'auto' }}>
//                 {message.user && typeof message.user === 'string' && message.user.split("\n").map((line, index) => (
//                   <div key={index} style={{ wordBreak: "break-word" }}>
//                     {decodeContent(line)}
//                   </div>
//                 ))}
//               </Col>
//             </Row>
//           </Col>
//           <Row className="justify-content-end">
//             <Col xs={11} className="text-end">
//               <Row>
//                 <Col xs={11} style={{ margin: 'auto', paddingLeft: '40px', marginBottom: '40px',paddingTop:'10px'}} className={message.agent.length > 55 ? "text-start" : 'text-end'}>
//                   <Row>
//                     {message.agent &&
//                       typeof message.agent === 'string' &&
//                       message.agent.split("\\n").map((paragraph, index) => {
//                         let updatedParagraph = paragraph;
//                         if (findUrl(message.agent) && findUrl(message.agent).includes('dailylimitexceeded')) {
//                           // updatedParagraph = 'Your daily '+ getFileFormat(findUrl(message.agent))+' generation limit was exceeded. Consider upgrading to our premium plan for unlimited access to features.' ;
//                           updatedParagraph = `Hi there,\n\nIt looks like you’ve reached your daily limit for generating `+ getFileFormat(findUrl(message.agent))+` files. We’re really sorry about that! We know how important uninterrupted access is for you.\n\nTo keep enjoying all the great benefits and have a seamless experience, we’d love for you to consider upgrading to our premium plan.\n\nThank you so much for your understanding and support. We truly value having you with us and are excited to continue providing you with the best service possible.\n\nWarm regards,\n\nThe ModalX Team
//                           ` ;
//                           return (
//                             <div
//                               key={index}
//                               style={{ wordBreak: "break-word" }}
//                             >

//                               {/* <ReactMarkdown children={decodeContent(updatedParagraph)} remarkPlugins={[remarkGfm]} components={renderers} /> */}
//                               {/* <Markdown options={{overrides: renderers, }}>{decodeContent(updatedParagraph)}</Markdown> */}
//                               <div dangerouslySetInnerHTML={{ __html: md.render(decodeContent(updatedParagraph)) }} />
//                             </div>
//                           );
//                         }
//                         const cleanedParagraph = findUrl(message.agent) ? removeUrlsAndBrackets(paragraph) : paragraph;
//                         return (
//                           <div
//                             key={index}
//                             style={{ wordBreak: "break-word"}}
//                           >
//                             {/* <ReactMarkdown children={decodeContent(cleanedParagraph)} remarkPlugins={[remarkGfm]} components={renderers} /> */}
//                             {/* <Markdown options={{overrides: renderers, }}>{decodeContent(cleanedParagraph)}</Markdown> */}
//                             <div dangerouslySetInnerHTML={{ __html: md.render(decodeContent(cleanedParagraph)) }} />
//                           </div>
//                         );
//                       })}
//                   </Row>
//                   <Row>
//                     {
//                       findUrl(message.agent) &&
//                       <Row>
//                         <MessageActions
//                           message={{
//                             file: { url: findUrl(message.agent), mode: 'from_history', status: fileStatus }
//                           }}
//                           handleDownload={handleDownload}
//                           handlePreview={handlePreview}
//                         />
//                       </Row>
//                     }
//                   </Row>
//                 </Col>
//                 <Col xs={1} className="d-flex flex-column justify-content-start align-items-center p-0 m-0">
//                   <img style={{ width: '48px', height: '48px' }} src={theme === 'dark' ? black_logo : white_logo} alt="modalx_logo" />
//                 </Col>
//               </Row>
//               {message.file && (
//                 <Row>
//                   <MessageActions
//                     message={message}
//                     handleDownload={handleDownload}
//                     handlePreview={handlePreview}
//                   />
//                 </Row>
//               )}
//             </Col>
//           </Row>
//         </Row>
//       }
//     </Container>
//   );
// };

// export default MessageCard;

//==========================================updated code before on 04-09-2024  (above)======================================================


//==========================================Shabna Code Start (Update Date - 04-09-2024)======================================================
import React, { useEffect, useState } from "react";
import { Col, Row, Container, Image, Button } from "react-bootstrap";
import MessageActions from "./MessageActions";
import { useWorkspace } from "../../../contexts/WorkspaceContext";
import TypingIndicator from "./TypingIndicator";
import black_logo from "../../../assets/ModalX_-orange_Icon.png";
import white_logo from "../../../assets/modalX_robot_icon_white.png";
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import he from 'he';
import sourceUrl from "../../../api/Source.api";
import {decode} from 'html-entities';
import markdownit from 'markdown-it';
import MDEditor from '@uiw/react-md-editor';
import rehypeSanitize from "rehype-sanitize";
import './custom-markdown-styles.css'

const MessageCard = ({ message, handleDownload, handlePreview }) => {
  const token = localStorage.getItem('token');
  console.log("current_messages_from_history", message);
  const { waitThread,setCurrentThread,setWaitThread,sendMessage,setSending } = useWorkspace();
  const [theme, setTheme] = useState(localStorage.getItem('theme'));
  const [fileStatus, setFileStatus] = useState(null);
  const [input, setInput] = useState("");

  const findUrl = (msg) => {
    const urlRegex = /(https?:\/\/[^']*?\.(mp3|mp4|pptx|jpg|jpeg|png|txt|ppt))/g;
    const match = urlRegex.exec(msg);
    return match ? match[1] : null;
  };

  const removeUrlsAndBrackets = (msg) => {
    return msg.replace(/\(https?:\/\/[^']*?\.(mp3|mp4|pptx|jpg|jpeg|png|txt|ppt)\)/g, '');
  };

  useEffect(() => {
    // Update the theme when it changes
    const handleThemeChange = () => setTheme(localStorage.getItem('theme'));
    window.addEventListener('storage', handleThemeChange);

    return () => {
      window.removeEventListener('storage', handleThemeChange);
    };
  }, []);

  const handleCopyToClipboard = (text) => {
    navigator.clipboard.writeText(text)
      .then(() => {
        console.log('Link copied to clipboard:', text);
      })
      .catch((error) => {
        console.error('Error copying link to clipboard:', error);
      });
  };

  useEffect(() => {
    const url = findUrl(message.agent);
    if (url) {
      checkStatusFromHistoryUrl(url).then((status) => {
        setFileStatus(status);
      });
    }
  }, [message.agent]);

  const checkStatusFromHistoryUrl = async (url) => {
    try {
      const response = await fetch(`${sourceUrl}/status`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify({ url }),
      });

      const responseData = await response.json();
      if (responseData.data.status === "completed") {
        return "completed";
      } else if (responseData.data.status === "failed") {
        return "failed";
      } else {
        return null;
      }
    } catch (error) {
      console.error("Check URL status request error:", error);
      return null;
    }
  };

  const renderers = {
    a: ({ href, children }) => (
      <div style={{ display: 'inline-flex', alignItems: 'center', wordBreak: 'break-word' }}>
        <a href={href} target="_blank" rel="noopener noreferrer">{children}</a>
        <i
          className="bi bi-copy"
          style={{ cursor: 'pointer', marginLeft: '20px' }}
          onClick={() => handleCopyToClipboard(href)}
          title="Copy link"
        />
      </div>
    ),
  };

  const decodeUnicode = (str) => {
    // const stringWithoutDoubleBackslashes = str.split("\\\")
    const stringNewLine = str.split("\\n").join("\n")
    let stringNewLineWithAnchorTag = stringNewLine.replace(/\\u[\dA-F]{4}|u[\dA-F]{4}/gi, (match) => {
      const hexCode = match.replace(/\\?u/g, ''); // Remove '\u' or 'u'
      return String.fromCharCode(parseInt(hexCode, 16)); // Convert hex code to character
    });
    const finalString = stringNewLineWithAnchorTag.replace(/\\/g, '');
    return finalString
  };

// Function to decode HTML entities
const decodeContent = (content) => {
  return decodeUnicode((content));
};

  const handleSubmit = async (messageContent) => {
    setSending(true)
    setWaitThread(true);
    if (messageContent.trim()) {
      const latestEntry = { sender: "user", content: messageContent };
      setInput(""); // Reset input field
      setCurrentThread((prevThread) => [...prevThread, latestEntry]);
      const entryResponse = await sendMessage(latestEntry).catch(console.error);
      
      if (entryResponse) {
        setCurrentThread((prevThread) => [...prevThread, entryResponse]);
        setSending(false)
      }
      else{
        setCurrentThread((prevThread) => [...prevThread, {content:"Unable to process your query!..",sender:'modalX'}]);
        setSending(false);
      }
    }
    setWaitThread(false);
    // here add the functionality to check url status and update it in the currentThread
  };

  const handleRetry = () => {
    setCurrentThread((prevThread) => {
      const lastUserMessage = prevThread.filter(msg => msg.sender === "user").slice(-1)[0];
      const newThread = prevThread.slice(0, -1);
      handleSubmit(lastUserMessage.content); // Retry the submission with the last user message
      return newThread;
    });
  };

  const getFileFormat = (url) => {
    // Extract the file extension from the URL
    const parts = url.split('.');
    if (parts.length > 1) {
      return parts[parts.length - 1]; // Return the last part as the file format
    } else {
      return ''; // Return empty string if no file extension found
    }
  };

  function renderResponse(response){  
    response = findUrl(response) ? removeUrlsAndBrackets(response) : response;                   
    if (findUrl(response) && findUrl(response).includes('dailylimitexceeded')) {
      // updatedParagraph = 'Your daily '+ getFileFormat(findUrl(message.agent))+' generation limit was exceeded. Consider upgrading to our premium plan for unlimited access to features.' ;
      let updatedParagraph = `Hi there,\n\nIt looks like you’ve reached your daily limit for generating `+ getFileFormat(findUrl(response))+` files. We’re really sorry about that! We know how important uninterrupted access is for you.\n\nTo keep enjoying all the great benefits and have a seamless experience, we’d love for you to consider upgrading to our premium plan.\n\nThank you so much for your understanding and support. We truly value having you with us and are excited to continue providing you with the best service possible.\n\nWarm regards,\n\nThe ModalX Team`
     
       return <div style={{ wordBreak: "break-word" }}>
          <MDEditor.Markdown source={decodeUnicode(updatedParagraph)} style={{backgroundColor:"#171A2D", color:"white" }} previewOptions={{rehypePlugins: [[rehypeSanitize]],}}/> 
        </div>
      
    }else{
      return <div style={{ wordBreak: "break-word",  }}>
        <MDEditor.Markdown source={decodeUnicode(response)} style={{ backgroundColor:"#171A2D", color:"white"}}  className="custom-md-editor"/>
      </div>
    } 
}

const renderFirstTimeResponse = (response) =>{
    const cleanedParagraph = findUrl(response) ? removeUrlsAndBrackets(response) : response;
     return <div style={{ wordBreak: "break-word" }}>
        <MDEditor.Markdown source={decodeUnicode(cleanedParagraph)} style={{ backgroundColor:"#171A2D", color:"white"}}  className="custom-md-editor" previewOptions={{rehypePlugins: [[rehypeSanitize]]}} />
      </div>
}

  return (
  //   <Container fluid > 
  //   {message.sender ?
  //     <Row className="pb-3" >
  //       {message.sender === "user" ? (
  //         <Col xs={11} className="text-start" style={{ marginBottom: '20px', paddingRight: '70px',paddingLeft:'40px'}}>
  //           <Row>
  //             <Col xs={1} className="d-flex flex-column justify-content-start align-items-center p-0 m-0" style={{backgroundColor:'#1F233E',borderRadius:'50%',width:'48px',height:'48px'}}>
  //               <i className="bi bi-person fs-4" style={{margin:'auto'}}/>
  //             </Col>
  //             <Col xs={11} style={{ margin: 'auto' }}>
  //               {message.content && typeof message.content === 'string' && message.content.split("\n").map((line, index) => (
  //                 <div key={index} style={{ wordBreak: "break-word" }}>
  //                   {decodeContent(line)}
  //                 </div>
  //               ))}
  //             </Col>
  //           </Row>
  //         </Col>
  //       ) : (
  //         <Row className="justify-content-end" >
  //           <Col xs={11} className="text-end" style={{ marginBottom: '40px'}}>
  //             <Row>
  //               <Col xs={11} style={{ margin: 'auto', paddingRight: message.content.length < 44 ? '20px' : '',paddingTop:'10px'}} className={message.content.length > 55 ? "text-start" : 'text-end'}>
  //                 {/* {message.content &&
  //                   typeof message.content === 'string' &&
  //                   message.content.split("\\n").map((paragraph, index) => {
  //                     return (
  //                       <div
  //                         key={index}
  //                         style={{ wordBreak: "break-word" }}
  //                       >
  //                         <ReactMarkdown children={decodeContent(paragraph)} remarkPlugins={[remarkGfm]} components={renderers} />
  //                       </div>
  //                     );
  //                   })} */}
  //                   {message.content &&
  //                   typeof message.content === 'string' && renderFirstTimeResponse(message.content)}
  //               </Col>
  //               <Col xs={1} className="d-flex flex-column justify-content-start align-items-center p-0 m-0">
  //                 <img style={{ width: '48px', height: '48px'}} src={theme === 'dark' ? black_logo : white_logo} alt="modalx_logo" />
  //               </Col>
  //             </Row>
  //             {message.file && (
  //               <Row>
  //                 <MessageActions
  //                   message={message}
  //                   handleDownload={handleDownload}
  //                   handlePreview={handlePreview}
  //                 />
  //               </Row>
  //             )}
  //             {message.content === 'Unable to process your query!..' ? (
  //               <div style={{display:'flex',justifyContent:'right'}}>
  //                 <Button
  //                 onClick={handleRetry}
  //                 style={{ marginTop: "10px",maxWidth:'300px',border:'2px solid red',backgroundColor:'transparent'}}
  //               >
  //                 Regenerate Response <i class="bi bi-arrow-repeat"></i>
  //               </Button>
  //               </div>
                
  //             ):''}
  //           </Col>
  //         </Row>
  //       )}
  //     </Row>
  //     :
  //     <Row className="pb-3">
  //       <Col xs={11} className="text-start" style={{ marginBottom: '20px', paddingRight: '70px',paddingLeft:'40px'}}>
  //         <Row>
  //           <Col xs={1} className="d-flex flex-column justify-content-start align-items-center p-0 m-0" style={{backgroundColor:'#1F233E',borderRadius:'50%',width:'48px',height:'48px'}}>
  //             <i className="bi bi-person fs-4" style={{margin:'auto'}}/>
  //           </Col>
  //           <Col xs={11} style={{ margin: 'auto' }}>
  //             {message.user && typeof message.user === 'string' && message.user.split("\n").map((line, index) => (
  //               <div key={index} style={{ wordBreak: "break-word" }}>
  //                 {decodeContent(line)}
  //               </div>
  //             ))}
  //           </Col>
  //         </Row>
  //       </Col>
  //       <Row className="justify-content-end">
  //         <Col xs={11} className="text-end">
  //           <Row>
  //             <Col xs={11} style={{ margin: 'auto', paddingLeft: '40px', marginBottom: '40px',paddingTop:'10px'}} className={message.agent.length > 55 ? "text-start" : 'text-end'}>
  //               <Row>
  //                 {message.agent &&
  //                   typeof message.agent === 'string' && renderResponse(message.agent)}
  //               </Row>
  //               <Row>
  //                 {
  //                   findUrl(message.agent) &&
  //                   <Row>
  //                     <MessageActions
  //                       message={{
  //                         file: { url: findUrl(message.agent), mode: 'from_history', status: fileStatus }
  //                       }}
  //                       handleDownload={handleDownload}
  //                       handlePreview={handlePreview}
  //                     />
  //                   </Row>
  //                 }
  //               </Row>
  //             </Col>
  //             <Col xs={1} className="d-flex flex-column justify-content-start align-items-center p-0 m-0">
  //               <img style={{ width: '48px', height: '48px' }} src={theme === 'dark' ? black_logo : white_logo} alt="modalx_logo" />
  //             </Col>
  //           </Row>
  //           {message.file && (
  //             <Row>
  //               <MessageActions
  //                 message={message}
  //                 handleDownload={handleDownload}
  //                 handlePreview={handlePreview}
  //               />
  //             </Row>
  //           )}
  //         </Col>
  //       </Row>
  //     </Row>
  //   }
  // </Container>

    <Container fluid > 
      {message.sender ?
        <Row className="pb-3" >
          {message.sender === "user" ? (
            <Col xs={12} className="text-end" style={{ marginBottom: '20px', paddingRight: '30px',paddingLeft:'40px', backgroundColor: ''}}>
              <Row style={{backgroundColor : ''}}>

              <Col xs={11} style={{ margin: 'auto' , backgroundColor : '',display : 'flex',marginRight : '20px',alignItems : "center",
                  justifyContent : 'end'}}>
                {message.content && typeof message.content === 'string' && message.content.split("\n").map((line, index) => (
                  <div key={index} style={{ wordBreak: "break-word",textAlign : 'start', marginRight : '-13px' 
                  ,backgroundColor : '', maxWidth : '95%',
                  display : 'flex',
                  justifyContent : 'end'

                  }}>
                    {decodeContent(line)}
                  </div>
                ))}
                <Col xs={1}  style={{backgroundColor:'#1F233E',borderRadius:'50%',width:'48px',height:'48px', marginLeft : '30px',marginRight : '-30px', display : "flex", justifyContent : 'center', alignItems : "center"}}>
                <i  className="bi bi-person fs-4" style={{}}/>
              </Col>
              </Col>

              </Row>
            </Col>
          ) : (
            <Row className="justify-content-end" style={{ backgroundColor : ''}} >
                            
              <Col xs={11} className="text-end" style={{ marginBottom: '40px',backgroundColor : ''}}>
                <Row style={{backgroundColor : '', marginLeft : '-86px',backgroundColor : ''}} >
                <Col style={{width: '48px', height: '48px', backgroundColor : '#1F233E', marginRight : '', marginLeft : '27px', borderRadius : '24px'}} xs={1} >
                    <img style={{ width: '24px', height: '24px' , marginTop : '12px'}} src={theme === 'dark' ? black_logo : white_logo} alt="modalx_logo" />
                  </Col>
                  <Col xs={11} style={{ margin: 'auto' ,paddingTop:'10px',
                    backgroundColor : '',width : '87%', marginLeft : '10px'
                  }} className={message.content.length > 55 ? "text-start" : 'text-start'}>
                  
                      {message.content &&
                      typeof message.content === 'string' && renderFirstTimeResponse(message.content)}
                  </Col>
                </Row >
                {message.file && (
                  <Row style={{backgroundColor : '', marginLeft : '-1px'}}>
                    <MessageActions
                      message={message}
                      handleDownload={handleDownload}
                      handlePreview={handlePreview}
                    />
                  </Row>
                )}
                {message.content === 'Unable to process your query!..' ? (
                  <div style={{display:'flex',justifyContent:'right'}}>
                    <Button
                    onClick={handleRetry}
                    style={{ marginTop: "10px",maxWidth:'300px',border:'2px solid red',backgroundColor:'transparent'}}
                  >
                    Regenerate Response <i class="bi bi-arrow-repeat"></i>
                  </Button>
                  </div>
                  
                ):''}
              </Col>
            </Row>
          )}
        </Row>
        :
        <Row className="pb-3">
          <Col xs={12} className="text-end" style={{ marginBottom: '20px', paddingRight: '30px',paddingLeft:'30px',backgroundColor : ''}}>
            <Row style={{ backgroundColor : ''}}>

              <Col  style={{ margin: 'auto' , backgroundColor : '',display : 'flex',marginRight : '20px',
                  justifyContent : 'end'}}>
                {message.user && typeof message.user === 'string' && message.user.split("\n").map((line, index) => (
                  <div key={index} style={{ wordBreak: "break-word", textAlign : 'start', marginRight : '-13px' 
                    ,backgroundColor : '', maxWidth : '95%'}}>
                    {decodeContent(line)}
                  </div>
                ))}
              </Col>
              <Col xs={1} className="d-flex flex-column justify-content-start align-items-center p-0 m-1" style={{backgroundColor:'#1F233E',borderRadius:'50%',width:'48px',height:'48px'}}>
                <i className="bi bi-person fs-4" style={{margin:'auto'}}/>
              </Col>
            </Row>
          </Col>
          <Row className="justify-content-end" style={{backgroundColor : ''}}>

            <Col xs={11} className="text-end" style={{ marginBottom: '40px',backgroundColor : ''}}>
              <Row style={{ marginLeft : '-86px',backgroundColor : ''}}>

                  <Col style={{width: '48px', height: '48px', backgroundColor : '#1F233E', marginRight : '', marginLeft : '7px', borderRadius : '24px'}} xs={1} >
                    <img style={{ width: '24px', height: '24px' , marginTop : '12px'}} src={theme === 'dark' ? black_logo : white_logo} alt="modalx_logo" />
                  </Col>
                <Col xs={11} style={{ margin: 'auto',paddingTop:'10px',
                    backgroundColor : '', marginLeft : '10px', width : '90%'}} className={message.agent.length > 55 ? "text-start" : 'text-start'}>
                {/* paddingTop:'10px',
                    backgroundColor : 'pink',width : '620px', marginLeft : '10px' */}
                  <Row style={{}}>
                    {message.agent &&
                      typeof message.agent === 'string' && renderResponse(message.agent)}
                  </Row>
                  <Row>
                    {
                      findUrl(message.agent) &&
                      <Row style={{backgroundColor : '',width : '', marginLeft : ''}}>
                        <MessageActions
                          message={{
                            file: { url: findUrl(message.agent), mode: 'from_history', status: fileStatus }
                          }}
                          handleDownload={handleDownload}
                          handlePreview={handlePreview}
                        />
                      </Row>
                    }
                  </Row>
                </Col>
                {/* <Col xs={1} className="d-flex flex-column justify-content-start align-items-center p-0 m-0">
                  <img style={{ width: '48px', height: '48px' }} src={theme === 'dark' ? black_logo : white_logo} alt="modalx_logo" />
                </Col> */}
              </Row>
              {message.file && (
                <Row >
                  <MessageActions
                    message={message}
                    handleDownload={handleDownload}
                    handlePreview={handlePreview}
                  />
                </Row>
              )}
            </Col>
          </Row>
        </Row>
      }
    </Container>
  );
};

export default MessageCard;

//===================(Lots Of modification Code)===============
// import React, { useEffect, useState } from "react";
// import { Col, Row, Container, Image, Button } from "react-bootstrap";
// import MessageActions from "./MessageActions";
// import { useWorkspace } from "../../../contexts/WorkspaceContext";
// import TypingIndicator from "./TypingIndicator";
// import black_logo from "../../../assets/ModalX_-orange_Icon.png";
// import white_logo from "../../../assets/modalX_robot_icon_white.png";
// import ReactMarkdown from 'react-markdown';
// import remarkGfm from 'remark-gfm';
// import he from 'he';
// import sourceUrl from "../../../api/Source.api";
// import {decode, encode} from 'html-entities';
// import markdownit from 'markdown-it';
// import './custom-markdown-styles.css'
// import hljs from 'highlight.js';
// import MDEditor from '@uiw/react-md-editor';
// import rehypeSanitize from "rehype-sanitize";
// import 'highlight.js/styles/github.css'; // Use a theme similar to ChatGPT's code style


// const MessageCard = ({ message, handleDownload, handlePreview }) => {
//   const token = localStorage.getItem('token');
//   console.log("current_messages_from_history", message);
//   const { waitThread,setCurrentThread,setWaitThread,sendMessage,setSending } = useWorkspace();
//   const [theme, setTheme] = useState(localStorage.getItem('theme'));
//   const [fileStatus, setFileStatus] = useState(null);
//   const [input, setInput] = useState("");
//   const [res, setRes] = useState("");

//   const findUrl = (msg) => {
//     const urlRegex = /(https?:\/\/[^']*?\.(mp3|mp4|pptx|jpg|jpeg|png|txt|ppt))/g;
//     const match = urlRegex.exec(msg);
//     return match ? match[1] : null;
//   };

//   const removeUrlsAndBrackets = (msg) => {
//     return msg.replace(/\(https?:\/\/[^']*?\.(mp3|mp4|pptx|jpg|jpeg|png|txt|ppt)\)/g, '');
//   };

//   useEffect(() => {
//     // Update the theme when it changes
//     const handleThemeChange = () => setTheme(localStorage.getItem('theme'));
//     window.addEventListener('storage', handleThemeChange);

//     return () => {
//       window.removeEventListener('storage', handleThemeChange);
//     };
//   }, []);

//   const handleCopyToClipboard = (text) => {
//     navigator.clipboard.writeText(text)
//       .then(() => {
//         console.log('Link copied to clipboard:', text);
//       })
//       .catch((error) => {
//         console.error('Error copying link to clipboard:', error);
//       });
//   };

//   useEffect(() => {
//     const url = findUrl(message.agent);
//     if (url) {
//       checkStatusFromHistoryUrl(url).then((status) => {
//         setFileStatus(status);
//       });
//     }
//   }, [message.agent]);

//   const checkStatusFromHistoryUrl = async (url) => {
//     try {
//       const response = await fetch(`${sourceUrl}/status`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           "Authorization": `Bearer ${token}`
//         },
//         body: JSON.stringify({ url }),
//       });

//       const responseData = await response.json();
//       if (responseData.data.status === "completed") {
//         return "completed";
//       } else if (responseData.data.status === "failed") {
//         return "failed";
//       } else {
//         return null;
//       }
//     } catch (error) {
//       console.error("Check URL status request error:", error);
//       return null;
//     }
//   };

//   const renderers = {
//     a: ({ href, children }) => (
//       <div style={{ display: 'inline-flex', alignItems: 'center', wordBreak: 'break-word' }}>
//         <a href={href} target="_blank" rel="noopener noreferrer">{children}</a>
//         <i
//           className="bi bi-copy"
//           style={{ cursor: 'pointer', marginLeft: '20px' }}
//           onClick={() => handleCopyToClipboard(href)}
//           title="Copy link"
//         />
//       </div>
//     ),
//   };

//   const decodeUnicode = (str) => {
//     const stringNewLine = str.split("\\n").join("\n")
//     const stringNewLineWithAnchorTag = stringNewLine.replace(/\\u[\dA-F]{4}|u[\dA-F]{4}/gi, (match) => {
//       const hexCode = match.replace(/\\?u/g, ''); // Remove '\u' or 'u'
//       return String.fromCharCode(parseInt(hexCode, 16)); // Convert hex code to character
//     });
//     return stringNewLineWithAnchorTag

//   };
  
//   const md = markdownit({
//     html: true,
//     linkify: true,
//     typographer: true,
//     quotes: '“”‘’',
//     highlight: function (str, lang) {
//       if (lang && hljs.getLanguage(lang)) {
//         try {
//           return '<pre class="hljs"><code>' +
//                  hljs.highlight(lang, str, true).value +
//                  '</code></pre>';
//         } catch (__) {}
//       }
  
//       return '<pre class="hljs"><code>' + md.utils.escapeHtml(str) + '</code></pre>';
//     }
//   })


//   const handleSubmit = async (messageContent) => {
//     setSending(true)
//     setWaitThread(true);
//     if (messageContent.trim()) {
//       const latestEntry = { sender: "user", content: messageContent };
//       setInput(""); // Reset input field
//       setCurrentThread((prevThread) => [...prevThread, latestEntry]);
//       const entryResponse = await sendMessage(latestEntry).catch(console.error);
      
//       if (entryResponse) {
//         setCurrentThread((prevThread) => [...prevThread, entryResponse]);
//         setSending(false)
//       }
//       else{
//         setCurrentThread((prevThread) => [...prevThread, {content:"Unable to process your query!..",sender:'modalX'}]);
//         setSending(false);
//       }
//     }
//     setWaitThread(false);
//     // here add the functionality to check url status and update it in the currentThread
//   };

//   const handleRetry = () => {
//     setCurrentThread((prevThread) => {
//       const lastUserMessage = prevThread.filter(msg => msg.sender === "user").slice(-1)[0];
//       const newThread = prevThread.slice(0, -1);
//       handleSubmit(lastUserMessage.content); // Retry the submission with the last user message
//       return newThread;
//     });
//   };

//   const getFileFormat = (url) => {
//     // Extract the file extension from the URL
//     const parts = url.split('.');
//     if (parts.length > 1) {
//       return parts[parts.length - 1]; // Return the last part as the file format
//     } else {
//       return ''; // Return empty string if no file extension found
//     }
//   };

//   function renderResponse(response){  
//     response = findUrl(response) ? removeUrlsAndBrackets(response) : response;                   
//     if (findUrl(response) && findUrl(response).includes('dailylimitexceeded')) {
//       // updatedParagraph = 'Your daily '+ getFileFormat(findUrl(message.agent))+' generation limit was exceeded. Consider upgrading to our premium plan for unlimited access to features.' ;
//       let updatedParagraph = `Hi there,\n\nIt looks like you’ve reached your daily limit for generating `+ getFileFormat(findUrl(response))+` files. We’re really sorry about that! We know how important uninterrupted access is for you.\n\nTo keep enjoying all the great benefits and have a seamless experience, we’d love for you to consider upgrading to our premium plan.\n\nThank you so much for your understanding and support. We truly value having you with us and are excited to continue providing you with the best service possible.\n\nWarm regards,\n\nThe ModalX Team`
     
//        return <div

//           style={{ wordBreak: "break-word" }}>

//           {/* <ReactMarkdown children={decodeContent(updatedParagraph)} remarkPlugins={[remarkGfm]} components={renderers} /> */}
//           <MDEditor.Markdown source={decodeUnicode(updatedParagraph)} style={{ }} previewOptions={{rehypePlugins: [[rehypeSanitize]],}}/> 
//         </div>
      
//     }else{
//     // let cleanedParagraph = findUrl(message.agent) ? removeUrlsAndBrackets(paragraph) : paragraph;
//     // cleanedParagraph = cleanedParagraph.replace('\\n', '\n');
//       return <div
//         style={{ wordBreak: "break-word",  }}
//       >
//         {/* <ReactMarkdown children={decodeContent(cleanedParagraph)} remarkPlugins={[remarkGfm]} components={renderers} /> */}
//         <MDEditor.Markdown source={decodeUnicode(response)} style={{ backgroundColor:"#171A2D", color:"white"}} previewOptions={{rehypePlugins: [[rehypeSanitize]]}} />
//       </div>
//     } 
// }

//   return (
//     <Container fluid > 
//       {message.sender ?
//         <Row className="pb-3" >
//           {message.sender === "user" ? (
//             <Col xs={11} className="text-start" style={{ marginBottom: '20px', paddingRight: '70px',paddingLeft:'40px'}}>
//               <Row>
//                 <Col xs={1} className="d-flex flex-column justify-content-start align-items-center p-0 m-0" style={{backgroundColor:'#1F233E',borderRadius:'50%',width:'48px',height:'48px'}}>
//                   <i className="bi bi-person fs-4" style={{margin:'auto'}}/>
//                 </Col>
//                 <Col xs={11} style={{ margin: 'auto' }}>
//                   {message.content && typeof message.content === 'string' && message.content.split("\n").map((line, index) => (
//                     <div key={index} style={{ wordBreak: "break-word" }}>
//                       {decodeUnicode(line)}
//                     </div>
//                   ))}
//                 </Col>
//               </Row>
//             </Col>
//           ) : (
//             <Row className="justify-content-end" >
//               <Col xs={11} className="text-end" style={{ marginBottom: '40px'}}>
//                 <Row>
//                   <Col xs={11} style={{ margin: 'auto', paddingRight: message.content.length < 44 ? '20px' : '',paddingTop:'10px'}} className={message.content.length > 55 ? "text-start" : 'text-end'}>
//                     {/* {message.content &&
//                       typeof message.content === 'string' &&
//                       message.content.split("\\n").map((paragraph, index) => {
//                         return (
//                           <div
//                             key={index}
//                             style={{ wordBreak: "break-word" }}
//                           >
//                             <ReactMarkdown children={decodeContent(paragraph)} remarkPlugins={[remarkGfm]} components={renderers} />
//                           </div>
//                         );
//                       })} */}
//                       {message.content &&
//                       typeof message.content === 'string' ? <div
//                       style={{ wordBreak: "break-word", padding:"20px 0px", }}
//                     >
//                       {/* <ReactMarkdown children={decodeContent(cleanedParagraph)} remarkPlugins={[remarkGfm]} components={renderers} /> */}
//                       {/* <div>{renderers}</div> */}
//                       {/* <Markdown options={{overrides: renderers, }}>{decodeContent(cleanedParagraph)}</Markdown> */}
//                       {/* <div dangerouslySetInnerHTML={{ __html: md.render(decodeContent(newString)) }} /> */}
//                       <MDEditor.Markdown source={decodeUnicode(findUrl(message.content) ? removeUrlsAndBrackets(message.content) : message.content)} style={{backgroundColor:"#171A2D",color:"white"}} previewOptions={{rehypePlugins: [[rehypeSanitize]],}}/>
//                     </div>
//                      : ""
//                       // message.agent.split("\n").map((paragraph, index) => {
//                       //   let cleanedParagraph = findUrl(message.agent) ? removeUrlsAndBrackets(paragraph) : paragraph;
//                       //   // cleanedParagraph = cleanedParagraph.replace('\\n', '\n');
//                       //   return (
//                       //     <div
//                       //       key={index}
//                       //       style={{ wordBreak: "break-word", padding:"20px 0px", }}
//                       //     >
//                       //       {/* <ReactMarkdown children={decodeContent(cleanedParagraph)} remarkPlugins={[remarkGfm]} components={renderers} /> */}
//                       //       {/* <div>{renderers}</div> */}
//                       //       {/* <Markdown options={{overrides: renderers, }}>{decodeContent(cleanedParagraph)}</Markdown> */}
//                       //       {/* <div dangerouslySetInnerHTML={{ __html: md.render(decodeContent(newString)) }} /> */}
//                       //       <MDEditor.Markdown source={decodeUnicode(cleanedParagraph)} style={{ }} previewOptions={{rehypePlugins: [[rehypeSanitize]],}}/>
//                       //     </div>
//                       //   );
//                       // }
//                       // )
//                       }
//                   </Col>
//                   <Col xs={1} className="d-flex flex-column justify-content-start align-items-center p-0 m-0">
//                     <img style={{ width: '48px', height: '48px'}} src={theme === 'dark' ? black_logo : white_logo} alt="modalx_logo" />
//                   </Col>
//                 </Row>
//                 {message.file && (
//                   <Row>
//                     <MessageActions
//                       message={message}
//                       handleDownload={handleDownload}
//                       handlePreview={handlePreview}
//                     />
//                   </Row>
//                 )}
//                 {message.content === 'Unable to process your query!..' ? (
//                   <div style={{display:'flex',justifyContent:'right'}}>
//                     <Button
//                     onClick={handleRetry}
//                     style={{ marginTop: "10px",maxWidth:'300px',border:'2px solid red',backgroundColor:'transparent'}}
//                   >
//                     Regenerate Response <i class="bi bi-arrow-repeat"></i>
//                   </Button>
//                   </div>
                  
//                 ):''}
//               </Col>
//             </Row>
//           )}
//         </Row>
//         :
//         <Row className="pb-3">
//           <Col xs={11} className="text-start" style={{ marginBottom: '20px', paddingRight: '70px',paddingLeft:'40px'}}>
//             <Row>
//               <Col xs={1} className="d-flex flex-column justify-content-start align-items-center p-0 m-0" style={{backgroundColor:'#1F233E',borderRadius:'50%',width:'48px',height:'48px'}}>
//                 <i className="bi bi-person fs-4" style={{margin:'auto'}}/>
//               </Col>
//               <Col xs={11} style={{ margin: 'auto' }}>
//                 {message.user && typeof message.user === 'string' && message.user.split("\n").map((line, index) => (
//                   <div key={index} style={{ wordBreak: "break-word" }}>
//                     {decodeUnicode(line)}
//                   </div>
//                 ))}
//               </Col>
//             </Row>
//           </Col>
//           <Row className="justify-content-end">
//             <Col xs={11} className="text-end">
//               <Row>
//                 <Col xs={11} style={{ margin: 'auto', paddingLeft: '40px', marginBottom: '40px',paddingTop:'10px'}} className={message.agent.length > 55 ? "text-start" : 'text-end'}>
//                   <Row>
//                     {message.agent &&
//                       typeof message.agent === 'string' &&  renderResponse(message.agent)}
                    
//                   </Row>
//                   <Row>
//                     {
//                       findUrl(message.agent) &&
//                       <Row>
//                         <MessageActions
//                           message={{
//                             file: { url: findUrl(message.agent), mode: 'from_history', status: fileStatus }
//                           }}
//                           handleDownload={handleDownload}
//                           handlePreview={handlePreview}
//                         />
//                       </Row>
//                     }
//                   </Row>
//                 </Col>
//                 <Col xs={1} className="d-flex flex-column justify-content-start align-items-center p-0 m-0">
//                   <img style={{ width: '48px', height: '48px' }} src={theme === 'dark' ? black_logo : white_logo} alt="modalx_logo" />
//                 </Col>
//               </Row>
//               {message.file && (
//                 <Row>
//                   <MessageActions
//                     message={message}
//                     handleDownload={handleDownload}
//                     handlePreview={handlePreview}
//                   />
//                 </Row>
//               )}
//             </Col>
//           </Row>
//         </Row>
//       }
//     </Container>
//   );
// };

// export default MessageCard;

//==========================================Shabna Code End======================================================


// ==================================updated code on 21-05-2024  (below)======================================
// import React, { useEffect, useState } from "react";
// import { Col, Row, Container, Image } from "react-bootstrap";
// import MessageActions from "./MessageActions";
// import { useWorkspace } from "../../../contexts/WorkspaceContext";
// import TypingIndicator from "./TypingIndicator";
// import black_logo from "../../../assets/modalX_robot_icon_black.png";
// import white_logo from "../../../assets/modalX_robot_icon_white.png";
// import ReactMarkdown from 'react-markdown';
// import remarkGfm from 'remark-gfm';
// import he from 'he';

// const MessageCard = ({ message, handleDownload, handlePreview }) => {
//   const token = localStorage.getItem('token');
//   console.log("current_messages_from_history", message);
//   const { waitThread } = useWorkspace();
//   const [theme, setTheme] = useState(localStorage.getItem('theme'));
//   const [fileStatus, setFileStatus] = useState(null);
//   const findUrl = (msg) => {
//     const urlRegex = /(https?:\/\/[^']*?\.(mp3|mp4|pptx|jpg|jpeg|png|txt|ppt))/g;
//     const match = urlRegex.exec(msg);
//     return match ? match[1] : null;
//   };
//   const removeUrlsAndBrackets = (msg) => {
//     return msg.replace(/\(https?:\/\/[^']*?\.(mp3|mp4|pptx|jpg|jpeg|png|txt|ppt)\)/g, '');
//   };

//   useEffect(() => {
//     // Update the theme when it changes
//     const handleThemeChange = () => setTheme(localStorage.getItem('theme'));
//     window.addEventListener('storage', handleThemeChange);

//     return () => {
//       window.removeEventListener('storage', handleThemeChange);
//     };
//   }, []);

//   const handleCopyToClipboard = (text) => {
//     navigator.clipboard.writeText(text)
//       .then(() => {
//         console.log('Link copied to clipboard:', text);
//       })
//       .catch((error) => {
//         console.error('Error copying link to clipboard:', error);
//       });
//   };

//   useEffect(() => {
//     const url = findUrl(message.agent);
//     if (url) {
//       checkStatusFromHistoryUrl(url).then((status) => {
//         setFileStatus(status);
//       });
//     }
//   }, [message.agent]);

//   const checkStatusFromHistoryUrl = async (url) => {
//     try {
//       const response = await fetch("https://www.modalx.ai/status", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           "Authorization": `Bearer ${token}`
//         },
//         body: JSON.stringify({ url }),
//       });

//       const responseData = await response.json();
//       // console.log("zzzzzzzzzzzzzzzzzzzz", responseData);
//       if (responseData.data.status === "completed") {
//         return "completed";
//       } else if (responseData.data.status === "failed") {
//         return "failed";
//       } else {
//         return null;
//       }

//     } catch (error) {
//       console.error("Check URL status request error:", error);
//       return null;
//     }
//   }

//   const renderers = {
//     a: ({ href, children }) => (
//       <div style={{ display: 'inline-flex', alignItems: 'center', wordBreak: 'break-word' }}>
//         <a href={href} target="_blank" rel="noopener noreferrer">{children}</a>
//         <i
//           className="bi bi-copy"
//           style={{ cursor: 'pointer', marginLeft: '20px' }}
//           onClick={() => handleCopyToClipboard(href)}
//           title="Copy link"
//         />
//       </div>
//     ),
//   };

//   return (
//     <Container fluid>
//       {message.sender ?
//         <Row className="pb-3">
//           {message.sender === "user" ? (
//             <Col xs={11} className="text-start" style={{ marginBottom: '20px', paddingRight: '70px' }}>
//               <Row>
//                 <Col xs={1} className="d-flex flex-column justify-content-start align-items-center p-0 m-0">
//                   <i className="bi bi-person fs-4" />
//                 </Col>
//                 <Col xs={11} style={{ margin: 'auto' }}>
//                   {message.content && typeof message.content === 'string' && message.content.split("\n").map((line, index) => (
//                     <div key={index} style={{ wordBreak: "break-word" }}>
//                       {he.decode(line)}
//                     </div>
//                   ))}
//                 </Col>
//               </Row>
//             </Col>
//           ) : (
//             <Row className="justify-content-end">
//               <Col xs={11} className="text-end" style={{ marginBottom: '40px' }}>
//                 <Row>
//                   <Col xs={11} style={{ margin: 'auto', paddingRight: message.content.length < 42 ? '20px' : '' }} className={message.content.length > 42 ? "text-start" : 'text-end'}>
//                     {message.content &&
//                       typeof message.content === 'string' &&
//                       message.content.split("\\n").map((paragraph, index) => {
//                         return (
//                           <div
//                             key={index}
//                             style={{ wordBreak: "break-word" }}
//                           >
//                             <ReactMarkdown children={he.decode(paragraph)} remarkPlugins={[remarkGfm]} components={renderers} />
//                           </div>
//                         );
//                       })}
//                   </Col>
//                   <Col xs={1} className="d-flex flex-column justify-content-start align-items-center p-0 m-0">
//                     <img style={{ width: '25px', height: '25px' }} src={theme === 'dark' ? black_logo : white_logo} alt="modalx_logo" />
//                   </Col>
//                 </Row>
//                 {message.file && (
//                   <Row>
//                     <MessageActions
//                       message={message}
//                       handleDownload={handleDownload}
//                       handlePreview={handlePreview}
//                     />
//                   </Row>
//                 )}
//               </Col>
//             </Row>
//           )}
//         </Row>
//         :
//         <Row className="pb-3">
//           <Col xs={11} className="text-start" style={{ marginBottom: '20px', paddingRight: '70px' }}>
//             <Row>
//               <Col xs={1} className="d-flex flex-column justify-content-start align-items-center p-0 m-0">
//                 <i className="bi bi-person fs-4" />
//               </Col>
//               <Col xs={11} style={{ margin: 'auto' }}>
//                 {message.user && typeof message.user === 'string' && message.user.split("\n").map((line, index) => (
//                   <div key={index} style={{ wordBreak: "break-word" }}>
//                     {he.decode(line)}
//                   </div>
//                 ))}
//               </Col>
//             </Row>
//           </Col>
//           <Row className="justify-content-end">
//             <Col xs={11} className="text-end">
//               <Row>
//                 <Col xs={11} style={{ margin: 'auto', paddingLeft: '40px', marginBottom: '40px' }} className={message.agent.length > 42 ? "text-start" : 'text-end'}>
//                   <Row>
//                     {/* {message.agent &&
//                       typeof message.agent === 'string' &&
//                       message.agent.split("\\n").map((paragraph, index) => {
//                         return (
//                           <div
//                             key={index}
//                             style={{ wordBreak: "break-word" }}
//                           >
//                             <ReactMarkdown children={he.decode(paragraph)} remarkPlugins={[remarkGfm]} components={renderers} />
//                           </div>
//                         );
//                       })} */}
//                       {message.agent &&
//                       typeof message.agent === 'string' &&
//                       message.agent.split("\\n").map((paragraph, index) => {
//                         const cleanedParagraph = findUrl(message.agent) ? removeUrlsAndBrackets(paragraph) : paragraph;
//                         return (
//                           <div
//                             key={index}
//                             style={{ wordBreak: "break-word" }}
//                           >
//                             <ReactMarkdown children={he.decode(cleanedParagraph)} remarkPlugins={[remarkGfm]} components={renderers} />
//                           </div>
//                         );
//                       })}
//                   </Row>
//                   <Row>
//                     {
//                       findUrl(message.agent) &&
//                       <Row>
//                         <MessageActions
//                           message={{
//                             file: { url: findUrl(message.agent), mode: 'from_history',status:fileStatus }
//                           }}
//                           handleDownload={handleDownload}
//                           handlePreview={handlePreview}
//                         />
//                       </Row>
//                     }
//                   </Row>
//                 </Col>
//                 <Col xs={1} className="d-flex flex-column justify-content-start align-items-center p-0 m-0">
//                   <img style={{ width: '25px', height: '25px' }} src={theme === 'dark' ? black_logo : white_logo} alt="modalx_logo" />
//                 </Col>
//               </Row>
//               {message.file && (
//                 <Row>
//                   <MessageActions
//                     message={message}
//                     handleDownload={handleDownload}
//                     handlePreview={handlePreview}
//                   />
//                 </Row>
//               )}
//             </Col>
//           </Row>
//         </Row>
//       }
//     </Container>
//   );
// };

// export default MessageCard;
// ==================================updated code on 21-05-2024  (above)======================================



// import React from "react";
// import { Col, Row, Container } from "react-bootstrap";
// import MessageActions from "./MessageActions";
// // import Image from "react-bootstrap/Image";
// // import GetLogo from "../../GetLogo";

// const MessageCard = ({ message, handleDownload, handlePreview }) => {
//   // const logoSrc = GetLogo();
//   return (
//     <Container fluid>
//       <Row className="pb-3">
//         {/* <Col xs={{ span: 1, offset: 0 }} className="pe-0 me-0 py-0 my-0">
//           <div
//             style={{
//               height: "24px",
//               minHeight: "24px",
//               maxHeight: "24px",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//             }}
//           >
//             {message.sender === "user" ? (
//               <i
//                 className="bi bi-person fs-4"
//                 style={{ margin: "0", padding: "0" }}
//               />
//             ) : (
//               <Image
//                 src={logoSrc}
//                 loading="lazy"
//                 alt="Company Logo"
//                 width="24px"
//                 minWidth="24px"
//                 style={{
//                   objectFit: "cover",
//                 }}
//               />
//             )}
//           </div>
//         </Col> */}

//         <Col
//           xs={1}
//           className="d-flex flex-column justify-content-start align-items-center p-0 m-0"
//         >
//           <i
//             className={`bi ${
//               message.sender === "user" ? "bi-person" : "bi-robot"
//             } fs-4`}
//           />
//         </Col>
//         <Col xs={11}>
//           <Row>
//             {message.content.split("\n").map((line, index) => (
//               <div key={index} style={{ wordBreak: "break-word" }}>
//                 {line}
//               </div>
//             ))}
//           </Row>
//           {message.file && (
//             <Row>
//               <MessageActions
//                 message={message}
//                 handleDownload={handleDownload}
//                 handlePreview={handlePreview}
//               />
//             </Row>
//           )}
//         </Col>
//       </Row>
//     </Container>
//   );
// };

// export default MessageCard;
